export const MODULES = Object.freeze({
  SETTINGS: 'settings',
  FUELSTATIONS: 'fuelStations',
  CENTERS: 'centers',
  CENTERS_OWN: 'centers/own',
  PURCHASE_FUEL: 'purchases',
  USERS: 'users',
  ALVIC: 'alvic',
  ACCOUNTING_ENTRY: 'accountingEntry',
  CASH_REGISTERS: 'cashRegisters',
})

const cashRegistersGroups = Object.freeze({
  CASH_REGISTERS: 'cashRegisters',
})

const accountingEntryGroups = Object.freeze({
  ACCOUNTING_ENTRY: 'accountingEntry',
  ACCOUNTING_ENTRY_GENERATOR: 'accountingEntryGeneration',
  ACCOUNTING_ENTRY_PROJECT_DISTRIBUTION_ANALYSIS:
    'accountingEntryProjectDistributionAnalysis',
  ACCOUNTING_ENTRY_SALARY_CONCEPT: 'accountingEntrySalaryConcept',
})

const purchasesGroups = Object.freeze({
  NEEDS: 'needs',
  SUPPLIERS: 'suppliers',
  PROPOSAL: 'proposal',
  MADE: 'made',
})

const generalGroups = Object.freeze({
  BILLABLES: 'billables',
  CONVENTIONS: 'conventions',
  INPUTS: 'inputs',
  POPULATIONS: 'populations',
  STATES: 'states',
})

export const GROUPS = Object.freeze({
  BASIC_INFO: 'basicInfo',
  ROLES: 'roles',
  COMPANIES: 'companies',
  MUTUAL: 'mutual',
  FUELSTATIONS: 'fuelStations',
  FAVORITE: 'favorite',

  // Centers
  CENTERS: 'centers',
  OWN: 'own',
  FRANCHISE: 'franchise',
  OTHER: 'other',

  PRICES: 'prices',
  ALVIC: 'alvic',
  NOTIFICATION: 'notification',
  SEVERAL: 'several',
  ENSENYA: 'ensenya',
  MANUALS: 'manuals',
  ACCESS_USERS: 'accessUsers',
  CONSUMPTION: 'consumption',
  STOCK: 'stock',
  DOWNLOADS: 'downloads',
  TANKS: 'tanks',
  MARGIN: 'margin',

  ...cashRegistersGroups,
  ...purchasesGroups,
  ...accountingEntryGroups,
  ...generalGroups,
})

export const METHOD = Object.freeze({
  POST: 'post',
  GET: 'get',
  PATCH: 'patch',
  DELETE: 'delete',
})
